
// src/web/components/pickup-diaries-page.jsx

import React from 'react'
import PureComponent from '../../helpers/pure-component'
import ReactDOM from 'react-dom'
import connect from '../../connects/pickup-diaries-page'
import RightSidePage from './right-side-page.jsx'
import Loading from './loading.jsx'
import Diary from './diary.jsx'
import { InfiniteScroll, InviewSensor } from './infinite-scroller'

class PickupDiariesPage extends PureComponent {
  onReplyScrollFrom = (offset)=> {
    //COMMENT_FORM_HEIGHTはコメントフォームの高さ
    const COMMENT_FORM_HEIGHT = 222
    //返信コメントへの返信の場合、コメントフォームまでスクロールする
    this.rightSidePage.scrollTo(offset += COMMENT_FORM_HEIGHT)
  }
  render() {
    const {
      t,
      diary_ids,
      diaries,
      user,
      group,
      readDiary,
      fetchDiaries,
      hasMore,
      isFetching,
      isFetchFailed,
      likeConfig,
      rightSidePage,
    } = this.props

    return (
      <RightSidePage title={t('label:ピックアップ')} icon="bookmark" innerRef={(c)=> this.rightSidePage = c}>
        {!isFetchFailed &&
          <InfiniteScroll pageStart={0}
            hasMore={hasMore && !isFetchFailed}
            loadMore={()=> !isFetching && fetchDiaries(this.props)}
            loader={diaries && <Loading />}
            useWindow={false}>
            {_.map(diaries, (diary)=> 
              <Diary key={diary.diary_id} diary={diary} user={user} group={group} isPickup={true} isShowAllComments={true} onReplyScrollFrom={this.onReplyScrollFrom} likeConfig={likeConfig} openSidePage={rightSidePage} isReviewButtonDisplay={false}/>
            )}
          </InfiniteScroll>
        }

        {!isFetchFailed && !diaries && isFetching &&
          <Loading />
        }
        {isFetchFailed && 
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:投稿の取得に失敗しました')}</div>
        }
        {!isFetching && !isFetchFailed && (!diaries || diaries && diaries.length == 0) &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {t('label:投稿がありません')}
          </div>
        }
      </RightSidePage>
    )
  }
}

export const RawPickupDiariesPage = PickupDiariesPage
export default connect(PickupDiariesPage)



// WEBPACK FOOTER //
// ./src/web/components/pickup-diaries-page.jsx